if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.customSubmitButton = this.dataset.customAddButton || 'false';
        
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // -------------------------------- Custom Add To Cart Buttons (SymmetryCommerce) --------------------------------
        if(this.customSubmitButton === 'true') {
          this.addIconWrap = this.querySelector('.atc-icon-wrap .add-icon-wrap');
          this.addedIconWrap = this.querySelector('.atc-icon-wrap .added-icon-wrap');
          // Store original hidden state of spans for restoration
          this.originalSpanStates = new Map();
          this.storeOriginalSpanStates();
        }
        // -------------------------------- Custom Add To Cart Buttons (SymmetryCommerce) --------------------------------
      }

      // -------------------------------- Custom Add To Cart Buttons (SymmetryCommerce) --------------------------------
      storeOriginalSpanStates() {
        // Store the original removed state of all spans except atc-icon-wrap
        this.submitButton.querySelectorAll('span:not(.atc-icon-wrap)').forEach(span => {
          this.originalSpanStates.set(span, span.classList.contains('removed'));
        });
      }

      showAddedState() {
        // Hide loading spinner and all other spans, then show added state
        this.querySelector('.loading__spinner').classList.add('hidden');
        this.submitButton.querySelectorAll('span:not(.atc-icon-wrap)').forEach(span => {
          span.classList.add('removed');
        });
        this.addedIconWrap.classList.remove('removed');
      }

      // This is in order to maintain the removed state of some spans inside the of the button (i.e. sold out) when they shouldn't be displayed
      restoreOriginalState() {
        // Restore original removed state of spans and show add state
        this.originalSpanStates.forEach((wasRemoved, span) => {
          if (wasRemoved) {
            span.classList.add('removed');
          } else {
            span.classList.remove('removed');
          }
        });
        this.addedIconWrap.classList.add('removed');
        this.addIconWrap.classList.remove('removed');
        // Remove loading class and hide spinner when done
        this.submitButton.classList.remove('loading');
        this.querySelector('.loading__spinner').classList.add('hidden');
      }
      // -------------------------------- Custom Add To Cart Buttons (SymmetryCommerce) --------------------------------

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        // -------------------------------- Custom Add To Cart Buttons (SymmetryCommerce) --------------------------------
        if (this.customSubmitButton === 'true') this.addIconWrap.classList.add('removed');
        // -------------------------------- Custom Add To Cart Buttons (SymmetryCommerce) --------------------------------
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            // -------------------------------- Custom Add To Cart Buttons (SymmetryCommerce) --------------------------------
            if (!this.error && this.customSubmitButton === 'true') {
              this.showAddedState();
              setTimeout(() => {
                this.submitButton.removeAttribute('aria-disabled');
                this.restoreOriginalState();
              }, 2000);
            } else {
              // If there's an error, restore state immediately
              this.submitButton.classList.remove('loading');
              this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
              if (this.customSubmitButton === 'true') this.restoreOriginalState();
            }
            // -------------------------------- Custom Add To Cart Buttons (SymmetryCommerce) --------------------------------
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const quickViewModal = document.getElementById('product-modal');
            
            if (quickViewModal) {
              quickViewModal.classList.remove('active');
              document.body.classList.remove('quickview-open');
            }

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            // -------------------------------- Custom Add To Cart Buttons (SymmetryCommerce) --------------------------------
            // No longer needed to remove aria-disabled as it's handled in the showAddedState() and restoreOriginalState() methods. Kept for reference.
            // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            // -------------------------------- Custom Add To Cart Buttons (SymmetryCommerce) --------------------------------
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
